var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.51 38.51",
    id: "x",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.66,
    x2: 37.84,
    y1: 3.65,
    y2: 34.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M16.16,20.54L6.82,6.95h8.09l6.94,6.98,6-6.98h3.36l7.29,7.44v-7.42c0-3.83-3.14-6.97-6.97-6.97H6.97C3.14,0,0,3.14,0,6.97v24.57c0,3.83,3.14,6.97,6.97,6.97h6.79l-7.08-6.95,9.48-11.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M38.51,31.54V14.38l-7.29-7.44h-3.36l-6,6.98-6.94-6.98H6.82l9.34,13.6-9.48,11.02,7.08,6.95h17.78c3.83,0,6.97-3.14,6.97-6.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.83,31.56h-8.09l-6.08-8.85-7.61,8.85h-3.36l9.48-11.02L6.82,6.95h8.09l5.75,8.36,7.2-8.36h3.36l-9.06,10.53,9.68,14.08ZM24.26,30.56h5.67l-9.04-13.15,8.14-9.47h-.72l-7.74,9-6.19-9h-5.67l8.7,12.66-8.56,9.95h.72l8.16-9.49,6.52,9.49ZM29.05,30.1h-4.35L9.58,8.48h4.35l15.11,21.62ZM25.22,29.1h1.91L13.41,9.48h-1.91l13.71,19.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.03d8bff019ff4d3c9700140dcbaf5fbe.svg";
export { ForwardRef as ReactComponent };